var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstantMix = function SvgInstantMix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "instant_mix_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#instant_mix_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 19v-6H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 12q0-.424.288-.713A.97.97 0 0 1 4 11h4q.424 0 .713.287Q9 11.576 9 12q0 .424-.287.713A.97.97 0 0 1 8 13H7v6q0 .424-.287.712A.97.97 0 0 1 6 20M6 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 8V5q0-.424.287-.713A.97.97 0 0 1 6 4q.424 0 .713.287Q7 4.576 7 5v3q0 .424-.287.713A.97.97 0 0 1 6 9m4 0a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 8q0-.424.287-.713A.97.97 0 0 1 10 7h1V5q0-.424.287-.713A.97.97 0 0 1 12 4q.424 0 .713.287Q13 4.576 13 5v2h1q.424 0 .713.287Q15 7.576 15 8q0 .424-.287.713A.97.97 0 0 1 14 9zm2 11a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 19v-7q0-.424.287-.713A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713v7q0 .424-.287.712A.97.97 0 0 1 12 20m6 0a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 19v-2h-1a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 16q0-.424.287-.713A.97.97 0 0 1 16 15h4q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 20 17h-1v2q0 .424-.288.712A.97.97 0 0 1 18 20m0-7a.97.97 0 0 1-.712-.287A.97.97 0 0 1 17 12V5q0-.424.288-.713A.97.97 0 0 1 18 4q.424 0 .712.287Q19 4.576 19 5v7q0 .424-.288.713A.97.97 0 0 1 18 13"
  }))));
};
export default SvgInstantMix;